/** React Query keys for public page reads (MYN-197, MYN-198). */
export const publicPagesKeys = {
  all: ['public-pages'] as const,
  detail: (slug: string) => ['public-pages', 'detail', slug] as const,
};
